import React from 'react';
import styles from './NuevoSistema.module.css';
import { Link } from 'react-router-dom';

const NuevoSistema = () => {
    return (
        <div className={`${styles.section} section`}>
            <div className={`container-lg flex flexRow space alignCenter ${styles.nuevoSistema}`}>
                <div className={styles.col60}>
                    <h4>Nuevo Sistema</h4>
                    <h2>
                        Protege y monitorea tu hogar o comercio con cámaras de seguridad
                    </h2>
                    <p>
                        Te damos la mejor tecnología para que puedas acceder remotamente y
                        conocer lo que esta pasando en directo, desde la palma de tu mano.
                    </p>
                    <Link to="/cotizador" className="btn">Cotizar Alarma</Link>
                </div>
                <div className={styles.col40}>
                    <img src="src/smart.png" alt="Smart" />
                </div>
            </div>
        </div>
    );
};

export default NuevoSistema;
